import isVideoFile from './isVideoFile';
import isImageFile from './isImageFile';

// handleFileInput.js
const handleFileInput = (e, setError, setFile, maxVideoSize, maxImageSize) => {
  const file = e.target.files[0];
  if (!file) {
    return;
  }

  const validTypes = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/avif',
    'image/heic',
    'image/heif',
    'image/heic-sequence',
    'image/heif-sequence',
    'video/mp4',
    'video/m4v',
    'video/webm',
    'video/ogg',
    'video/ogv',
    'video/quicktime', // MIME type for .mov files
    'video/x-flv',
    'video/3gpp',
    'video/3gpp2',
    'video/x-msvideo',
    'video/x-matroska',
  ];

  const nameLower = file.name.toLowerCase();
  const isVideo = isVideoFile(nameLower);
  const isImage = isImageFile(nameLower);
  const isGenericType =
    !file.type ||
    file.type === 'application/octet-stream' ||
    file.type === 'binary/octet-stream';

  if (!validTypes.includes(file.type) && !(isGenericType && (isImage || isVideo))) {
    setError(`${file.name} format is not supported.`);
    return;
  }

  if (isVideo && file.size > maxVideoSize) {
    setError(
      `${file.name} is too large, max ${
        maxVideoSize / (1024 * 1024)
      }mb allowed.`,
    );
    return;
  }

  if (!isVideo && file.size > maxImageSize) {
    setError(
      `${file.name} is too large, max ${
        maxImageSize / (1024 * 1024)
      }mb allowed.`,
    );
    return;
  }

  setFile(file);
};

export default handleFileInput;
